import { render, staticRenderFns } from "./OpenBalenaCard.vue?vue&type=template&id=b6cbe908&scoped=true&"
import script from "./OpenBalenaCard.vue?vue&type=script&lang=js&"
export * from "./OpenBalenaCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenBalenaCard.vue?vue&type=style&index=0&id=b6cbe908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cbe908",
  null
  
)

export default component.exports